import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Footer } from "../../../layout/footer/footer.component";
import { NormalNavbar } from "../../../layout/normal-navbar/normal-navbar";
import { SeoService } from '../../../core/services/seo/seo.service';

@Component({
  selector: 'app-disclaimer',
  standalone: true,
  imports: [CommonModule, RouterModule, NormalNavbar, Footer],
  templateUrl: './disclaimer.html',
  styleUrl: './disclaimer.scss'
})
export class DisclaimerComponent implements OnInit {

  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, 0);
    }
    this.seoService.setSeo({
      title: 'Disclaimer & DMCA',
      description: 'Scenetale Cinema Disclaimer and DMCA policy — content attribution, TMDB licensing, fair use, and copyright protection.',
      url: '/disclaimer',
      type: 'website'
    });
  }
}
